module.exports = __webpack_public_path__ + "static/media/Facebook.744fd1fd.svg";